import React from 'react';

import type { ContentType } from '../types/pbTypes';

export function getContentType(type: string): ContentType | undefined {
    switch (type) {
        case 'root-container':
            return 'root-container';

        case 'row':
            return 'row';

        case 'column-group':
            return 'column-group';

        case 'column-line':
            return 'column-line';

        case 'column':
            return 'column';

        case 'image':
            return 'image';

        case 'heading':
            return 'heading';

        case 'text':
            return 'text';

        case 'tabs':
            return 'tabs';

        case 'tab-item':
            return 'tab-item';

        case 'buttons':
            return 'buttons';

        case 'button-item':
            return 'button-item';

        case 'block':
            return 'block';

        case 'dynamic_block':
            return 'dynamic_block';

        case 'products':
            return 'products';

        case 'html':
            return 'html';

        case 'divider':
            return 'divider';

        case 'video':
            return 'video';

        case 'banner':
            return 'banner';

        case 'slider':
            return 'slider';

        case 'slide':
            return 'slide';

        case 'map':
            return 'map';

        default:
            return undefined;
    }
}

export const getImageMeta = (url: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Failed to load image: ${url}`));
        img.src = url;
    });
};

/**
 * React hook to get the width and height of a remote image URL
 * @param url The image URL to get dimensions for
 * @returns An object containing width and height or null if dimensions not available
 */
export const useImageDimensions = (url?: string) => {
    const [dimensions, setDimensions] = React.useState<{ width: number; height: number } | null>(null);

    React.useEffect(() => {
        if (!url) {
            setDimensions(null);
            return;
        }

        getImageMeta(url)
            .then((img) => {
                setDimensions({
                    width: img.width,
                    height: img.height,
                });
            })
            .catch((error) => {
                console.warn(`Failed to get dimensions for ${url}:`, error);
                setDimensions(null);
            });
    }, [url]);

    return dimensions;
};
